import React from 'react';

function Header() {
  return (
    <div className="container layout-shell rounded-t-lg pt-12 pb-4">
      <h1 className="text-center text-4xl">Covid Recovery</h1>
      <p className="text-center text-xl">A call to optimism - tracking covid recovery percentages</p>
    </div>
  )
}

export default Header
